import { z } from "zod";
const attributesHeadingSchema = z.object({
  slug: z.string(),
  level: z.coerce.number().int().min(1).max(6),
  uid: z.string(),
  isEditable: z.boolean().optional()
});
const attributesPageTitleSchema = z.object({
  title: z.string(),
  description: z.string().optional()
});
export {
  attributesHeadingSchema,
  attributesPageTitleSchema
};
//# sourceMappingURL=attributes.js.map
